<template>
    <div class="top_con">
       <el-form :inline="true" :model="formInline" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="用户名">
                    <el-input v-model="formInline.name" placeholder="请输入"></el-input>
                </el-form-item>
                <!-- <el-form-item label="手机号">
                    <el-input v-model="formInline.tel" placeholder="请输入"></el-input>
                </el-form-item> -->
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearSum">重置</el-button>
                    </el-form-item>
                </div>
           </el-row>
        </el-form>
        <el-button type="primary" @click="look(0)" style="margin-top:20px;">添加用户</el-button>
        <el-button type="primary" @click="look(1)" style="margin-top:20px;">编辑</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @current-change="handleSelectionChange" max-height="580px">
             <el-table-column  prop="username"  label="用户名"></el-table-column>
            <el-table-column  prop="tel"  label="手机号"></el-table-column>
            <el-table-column prop="role"  label="角色" ></el-table-column>
            <el-table-column prop="addtime"  label="添加时间" ></el-table-column>
            <el-table-column prop="upUser"  label="添加人" ></el-table-column>
            <el-table-column   label="状态">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="qy(0,scope.row.id)" style="margin-right:20px;" v-if="scope.row.status==1">启用</el-link>
                    <el-link :underline="false" @click="qy(1,scope.row.id)" style="margin-right:20px;" v-if="scope.row.status==0">禁用</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="50%">
                <el-form :model="form"  label-width="88px">
                    <el-row :gutter="10">
                        <el-col :span="10">
                            <el-form-item label="用户名"> 
                                <el-input v-model="form.name" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="手机号">
                                <el-input v-model="form.tel" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="10">
                            <el-form-item label="密码">
                                <el-input v-model="form.password" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="角色" style="width:100%;">
                                <el-select v-model="form.role" placeholder="请选择" style="margin-right:20px;" :disabled="tit_type==1?true:false" @change="edit_role">
                                    <el-option :label="item.role" :value="item.id" v-for="item in js_list" :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;" v-if="tit_type!=1">
                    <el-button type="primary" @click="subAdd" v-if="tit_type==0">确认添加</el-button>
                    <el-button type="primary" @click="subEdit" v-if="tit_type==2">确认修改</el-button>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {userInfo,userInfo_js,userAdd,userXinXi,userEdit,user_qj} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            userId:'',
            formInline: {
                name: ''
            },
            js_list:[],
            dialogFormVisible:false,
            zp_tit:"添加用户",
            tit_type:0,
            form:{
                name:'',
                tel:'',
                password:'',
                role:'',
                roleid:'',
            },
            formLabelWidth: '120px',
            value:10,
            total:12,
            multipleSelection:[],
            tableData: [],
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                username:this.formInline.name
            }
            userInfo(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        onSubmit(){
            let param ={
                numPerPage:this.value,
                pageNum:'1',
                username:this.formInline.name
            }
            userInfo(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        clearSum(){
            this.formInline={}
            userInfo().then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        look(idx){
            if(idx==0){
                this.dialogFormVisible=true
                this.form={};
                this.zp_tit="添加用户";
                this.tit_type=0;
            }else if(idx==1){
                if(this.multipleSelection!=''){
                    this.dialogFormVisible=true
                    this.zp_tit="编辑";
                    this.tit_type=2;
                    userXinXi({id:this.multipleSelection.id}).then(res=>{
                        this.form=res;
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '请先选择要修改的项'
                    });
                }
            }
        },
        qy(idx,id){
            this.$confirm('确定此操作, 是否继续?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let user=JSON.parse(localStorage.getItem('userInfo'))
                    let param ={
                        userId:this.user.uid,
                        id:id,
                        qy_jy:idx
                    }
                    user_qj(param).then(res=>{
                        if(idx==0){
                            this.$message({
                                type: 'success',
                                message: '禁用成功!'
                            });
                        }else{
                            this.$message({
                                type: 'success',
                                message: '启用成功!'
                            });
                        }
                        userInfo().then(res=>{
                            this.total=res.total;
                            this.tableData=res.list
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        subAdd(){
            this.form.roleid=this.form.role;
            this.user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userId:this.user.uid,
                forms:this.form
            }
            userAdd(param).then(res=>{
                this.$message({
                    type: 'success',
                    message: '添加成功!'
                });
                userInfo().then(res=>{
                    this.dialogFormVisible=false
                    this.total=res.total;
                    this.tableData=res.list
                });
            });
        },
        edit_role(){
             this.form.roleid=this.form.role;
        },
        subEdit(){
            let param ={
                userId:this.user.uid,
                forms:this.form
            }
            userEdit(param).then(res=>{
                userInfo().then(res=>{
                    this.dialogFormVisible=false
                    this.total=res.total,
                    this.tableData=res.list
                });
            });
        },
        del(id){
            this.$confirm('确定删除该条, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    userDel({id:id}).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        userInfo().then(res=>{
                            this.total=res.total;
                            this.tableData=res.list
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        userInfo().then(res=>{
            this.total=res.total;
            this.tableData=res.list
        });
        userInfo_js().then(res=>{
            this.js_list=res;
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/userGl.vue